<template>
  <v-row>
    <v-col cols="12">
      <wp-install />
    </v-col>
    <v-col cols="12">
      <installations-list />
    </v-col>
  </v-row>
</template>

<script>
import WpInstall from '@/components/Services/Hosting/Shared/Wordpress/WpInstall'
import InstallationsList from '@/components/Services/Hosting/Shared/Wordpress/InstallationsList'

export default {
  name: 'InstallAndManageView',
  components: {
    WpInstall,
    InstallationsList
  }
}
</script>
